import { render, staticRenderFns } from "./CoupassStaffAccounts.vue?vue&type=template&id=1a3cdcce&scoped=true"
import script from "./CoupassStaffAccounts.vue?vue&type=script&lang=js"
export * from "./CoupassStaffAccounts.vue?vue&type=script&lang=js"
import style0 from "./CoupassStaffAccounts.vue?vue&type=style&index=0&id=1a3cdcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3cdcce",
  null
  
)

export default component.exports